const DATABASE_CELL_EDITING_SELECTOR = [
  'affine-database-virtual-cell-container[data-database-cell-editing="true"]',
  'dv-table-view-cell-container[data-database-cell-editing="true"]',
].join(',');

const EDITABLE_KEYBOARD_TARGET_SELECTOR = [
  'input',
  'textarea',
  'select',
  '[contenteditable="true"]',
  '[contenteditable="plaintext-only"]',
  DATABASE_CELL_EDITING_SELECTOR,
].join(',');

function isEditableKeyboardTarget(target: EventTarget | null): boolean {
  if (!(target instanceof Element)) return false;
  if (target instanceof HTMLElement && target.isContentEditable) return true;

  return (
    target.matches(EDITABLE_KEYBOARD_TARGET_SELECTOR) ||
    target.closest(EDITABLE_KEYBOARD_TARGET_SELECTOR) !== null
  );
}

function isDatabaseCellEditingKeyboardTarget(
  target: EventTarget | null
): boolean {
  if (!(target instanceof Element)) return false;

  return (
    target.matches(DATABASE_CELL_EDITING_SELECTOR) ||
    target.closest(DATABASE_CELL_EDITING_SELECTOR) !== null
  );
}

export function isEditableKeyboardEventTarget(event: KeyboardEvent): boolean {
  if (event.isComposing) return true;
  const path =
    typeof event.composedPath === 'function'
      ? event.composedPath()
      : [event.target];
  return path.some(isEditableKeyboardTarget);
}

export function isDatabaseCellEditingKeyboardEventTarget(
  event: KeyboardEvent
): boolean {
  const path =
    typeof event.composedPath === 'function'
      ? event.composedPath()
      : [event.target];
  return path.some(isDatabaseCellEditingKeyboardTarget);
}

export function hasActiveDatabaseCellEditor(
  root: ParentNode = document
): boolean {
  if (root.querySelector(DATABASE_CELL_EDITING_SELECTOR)) return true;

  for (const element of root.querySelectorAll('*')) {
    if (element.shadowRoot && hasActiveDatabaseCellEditor(element.shadowRoot)) {
      return true;
    }
  }
  return false;
}
